import { ISetting, ISettingPreset } from '@newo/api/gateway';
import * as yup from 'yup';

export const settingsToDictionary = (
    settings: ISetting[] = [],
    settingsDescription: Record<string, ISettingPreset> = {}
) => {
    return settings.reduce<Record<string, string>>((accumulator, setting) => {
        if (setting.idn in settingsDescription) {
            accumulator[setting.idn] = String(setting.value);
        }
        return accumulator;
    }, {});
};

export const dictionaryToSettings = (dictionary: Record<string, unknown>) => {
    return Object.entries(dictionary).map(([idn, value]) => ({
        idn,
        value
    }));
};

export const buildSchema = (presets: ISettingPreset[]) => {
    const schema: Record<string, yup.AnySchema> = {};

    presets.forEach((preset) => {
        let fieldSchema;

        // Base schema based on value type
        switch (preset.value_type) {
            case 'int': {
                fieldSchema = yup.number().integer();
                break;
            }
            case 'float': {
                fieldSchema = yup.number();
                break;
            }
            case 'string':
            case 'external_sensitive_value': {
                fieldSchema = yup.string();
                break;
            }
            case 'list': {
                fieldSchema = yup.array().of(yup.string());
                break;
            }
            default: {
                fieldSchema = yup.string();
                break;
            }
        }

        // Add required validation if needed
        if (preset.is_required) {
            fieldSchema = fieldSchema.required();
        }

        // Add possible values validation if needed
        if (
            preset.strictly_possible_values &&
            preset.possible_values &&
            Array.isArray(preset.possible_values)
        ) {
            const possibleValues = preset.possible_values.map(String);
            if (
                preset.value_type === 'string' ||
                preset.value_type === 'external_sensitive_value'
            ) {
                fieldSchema = (fieldSchema as yup.StringSchema).oneOf(
                    possibleValues
                );
            } else if (
                preset.value_type === 'int' ||
                preset.value_type === 'float'
            ) {
                fieldSchema = (fieldSchema as yup.NumberSchema).oneOf(
                    possibleValues.map(Number)
                );
            }
        }

        schema[preset.idn] = fieldSchema;
    });

    return yup.object().shape(schema);
};
